import { productAction } from "../actionTypes";
const initialState = {
  productData: [],
  productList: [],
  subCategoryData: [],
  loader: false,
  orderListData: [],
  orderDetailsData: [],
  transactionListData: [],
  storeTransactionListData: [],
};

export default function product(state = initialState, { type, payload }) {
  switch (type) {
    case productAction.PRODUCT_LIST_INITIATE: {
      return {
        ...state,
        productList: [],
        loader: true,
      };
    }
    case productAction.PRODUCT_LIST_SUCCESS: {
      return {
        ...state,
        productList: payload,
        loader: false,
      };
    }
    case productAction.PRODUCT_LIST_FAILURE: {
      return {
        ...state,
        productList: [],
        loader: false,
      };
    }

    case productAction.PRODUCT_DETAILS_INITIATE: {
      return {
        ...state,
        productData: [],
        loader: true,
      };
    }
    case productAction.PRODUCT_DETAILS_SUCCESS: {
      return {
        ...state,
        productData: payload,
        loader: false,
      };
    }
    case productAction.PRODUCT_DETAILS_FAILURE: {
      return {
        ...state,
        productData: [],
        loader: false,
      };
    }

    case productAction.GET_SUB_CATEGORY_LIST_INITIATE: {
      return {
        ...state,
        subCategoryData: [],
        loader: true,
      };
    }
    case productAction.GET_SUB_CATEGORY_LIST_SUCCESS: {
      return {
        ...state,
        subCategoryData: payload,
        loader: false,
      };
    }
    case productAction.GET_SUB_CATEGORY_LIST_FAILURE: {
      return {
        ...state,
        subCategoryData: [],
        loader: false,
      };
    }

    case productAction.ORDER_LIST_INITIATE: {
      return {
        ...state,
        orderListData: [],
      };
    }
    case productAction.ORDER_LIST_SUCCESS: {
      return {
        ...state,
        orderListData: payload.data,
      };
    }

    case productAction.ORDER_LIST_FAILURE: {
      return {
        ...state,
        orderListData: payload.data,
      };
    }

    case productAction.ORDER_DETAILS_INITIATE: {
      return {
        ...state,
        orderDetailsData: [],
      };
    }
    case productAction.ORDER_DETAILS_SUCCESS: {
      return {
        ...state,
        orderDetailsData: payload,
      };
    }

    case productAction.ORDER_DETAILS_FAILURE: {
      return {
        ...state,
        orderDetailsData: payload.data,
      };
    }

    case productAction.TRANSACTION_LIST_INITIATE: {
      return {
        ...state,
        transactionListData: [],
      };
    }
    case productAction.TRANSACTION_LIST_SUCCESS: {
      return {
        ...state,
        transactionListData: payload,
      };
    }

    case productAction.TRANSACTION_LIST_FAILURE: {
      return {
        ...state,
        transactionListData: payload.data,
      };
    }

    case productAction.STORE_TRANSACTION_LIST_INITIATE: {
      return {
        ...state,
        storeTransactionListData: [],
      };
    }
    case productAction.STORE_TRANSACTION_LIST_SUCCESS: {
      return {
        ...state,
        storeTransactionListData: payload,
      };
    }

    case productAction.STORE_TRANSACTION_LIST_FAILURE: {
      return {
        ...state,
        storeTransactionListData: payload.data,
      };
    }

    default:
      return state;
  }
}
